import {
	DEFAULT_MEDIA_QUERY_PLATFORMS as MQ,
	COMPONENT_STATES as STATE,
	COMPONENT_TYPE as TYPE,
	UNIFORM_PROPS,
} from 'common/constants';
import { generateElementId, generateNodeId } from 'common/utils/generate-id';
import View from 'client/components/common/BuildingBlocks/Answer/Answer';

export const ANSWER = () => {
	const _id = generateElementId();

	return {
		view: View,
		model: {
			_id,
			type: TYPE.ANSWER,
			uiConfig: {
				layer: undefined,
				editorProps: {
					name: ANSWER.displayName,
					selectable: true,
					draggable: true,
					expandable: true,
					expanded: false,
				},
				nodeProps: {
					id: generateNodeId(_id, ANSWER.displayName),
				},
				componentProps: {
					[UNIFORM_PROPS.answerTimeout]: 0,
					styles: {
						[STATE.DEFAULT]: {
							[MQ.DEFAULT]: {},
							[MQ.DESKTOP]: {},
							[MQ.TABLET]: {},
							[MQ.MOBILE]: {},
						},
						[STATE.HOVER]: {
							[MQ.DEFAULT]: {},
						},
						[STATE.CORRECT]: {
							[MQ.DEFAULT]: {},
						},
						[STATE.INCORRECT]: {
							[MQ.DEFAULT]: {},
						},
					},
					other: {},
				},
			},
			children: [],
		},
	};
};

ANSWER.displayName = 'Answer';
